import React from 'react';
import PropTypes from 'prop-types';
import { TicketItemWrapper, TicketItemTitle, TicketItemValue } from './styles';

const TicketItem = ({
  ticketContent,
  ticketValue,
  onClick,
  isSelected,
  withBorders,
  withPanel,
  noPadding,
}) => (
  <TicketItemWrapper
    withPanel={withPanel}
    withBorders={withBorders}
    isSelected={isSelected}
    onClick={onClick}
  >
    <TicketItemTitle noPadding={noPadding}>{ticketContent}</TicketItemTitle>
    <TicketItemValue noPadding={noPadding}>{ticketValue}</TicketItemValue>
  </TicketItemWrapper>
);

TicketItem.defaultProps = {
  ticketContent: null,
  ticketValue: null,
  onClick: () => true,
  isSelected: false,
  withBorders: false,
  withPanel: false,
  noPadding: false,
};

TicketItem.propTypes = {
  noPadding: PropTypes.bool,
  withBorders: PropTypes.bool,
  withPanel: PropTypes.bool,
  ticketContent: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  ticketValue: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  onClick: PropTypes.func,
  isSelected: PropTypes.bool,
};

export default TicketItem;
